import React from 'react';
import './index.css';
import { Link } from 'react-router-dom';

const HeroSection = () => {
    return (
        <section id="hero" className="d-flex align-items-center">
            <div className="container">
                <div>
                    <small></small>
                    <h1>Best Dental Clinic in <br />Vidyaranyapura,Bangalore</h1>
                    <p>REDEFINING DENTAL EXPERIENCE <br />RESHAPING SMILES</p>
                </div>

            </div>
        </section>
    )
}
export default HeroSection;